<template>
    <div>
        <button class="kraken-button" @click="navigate" v-if="!isAnchor">
            {{ buttonText }}
        </button>
        <a class="kraken-button" :href="buttonLink" v-if="isAnchor">
            {{ buttonText }}
        </a>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'
    import VueRouter from 'vue-router'

    Vue.use(VueRouter)

    export default Vue.extend({
        name: 'KrakenButton',
        props: {
            buttonText: {
                type: String,
                default: 'K',
                validator( text ) {
                    return text.length === 1
                }
            },
            buttonLink: {
                type: String,
                default: '/'
            },
            isAnchor: Boolean
        },
        methods: {
            navigate() {
                if ( this.$route.path !== this.buttonLink )
                    this.$router.push({ path: this.buttonLink })
            }
        }
    })
</script>

<style scoped lang="scss">

.kraken {
    &-button {
        width: 130px;
        height: 130px;
        border-radius: 50%;
        border: none;
        box-shadow: 1px 3px 3px #393b439c;
        position: relative;
        background-color: #fff;
        color: #393B43;
        z-index: 1;
        cursor: pointer;
        font-size: 6rem;
        line-height: 8rem;
        font-family: 'Rubik', sans-serif;
        outline: #393b43cb;
        transition: all .25s;
        display: inline-block;
        text-decoration: none;
        text-align: center;

        &::before {
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            content: '';
            background-color: #393B43;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            transform: scale(.85);
            -webkit-transform: scale(.85);
            z-index: -2;
            transition: all .85s;
        }

        &::after {
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            content: '';
            background-color: #fff;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            transform: scale(.8);
            -webkit-transform: scale(.8);
            z-index: -2;
            transition: all .25s;
        }

        &:hover {
            transition: all .25s;
            box-shadow: 1px 3px 3px #393b431e;

            &::after {
                transform: scale(.85);
                -webkit-transform: scale(.85);
            }

            &::before {
                transform: scale(.9);
                -webkit-transform: scale(.9);
            }
        }
    }

    @media SCREEN AND ( min-width: 1500px ) {
        &-button {
            width: 170px;
            height: 170px;
            line-height: 10.5rem;
        }
    }

    @media SCREEN AND ( min-width: 2200px ) {
        &-button {
            width: 200px;
            height: 200px;
            line-height: 12.5rem;
        }
    }
}

</style>